module.exports = __webpack_public_path__ + "static/iosBannerTyres-1da506bd1b6ede7b93bf4debb381ee2e.png";